import React, { Component } from 'react';
import './styles.scss';
import {
  Box,
  HorizontalFormControl,
  NameFields,
} from '../../../../../../common/components';
import { Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import ButtonGroup from '../ReduxFormFields/ButtonGroup';
import { Col, FormGroup, ControlLabel } from 'react-bootstrap';
import { SelectField } from '../../../../../../common/components/ReduxFormField';

export class BankAccounts extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { content } = this.props;
    return (
      <Box>
        <FormGroup>
          <Col sm={12}>
            <h4 className="page-title">Bank Account details</h4>
          </Col>
        </FormGroup>
        {content.fields.map((field) => {
          if (field.name === 'data.attributes.metadata.bank_accounts.contact') {
            return (
              <>
                <h3>Monthly Accounts Contact Information</h3>
                <NameFields
                  key={field.name}
                  baseName={field.name}
                  label={field.label}
                  labelSize={3}
                />
              </>
            );
          }
          if (
            field.name ===
            'data.attributes.metadata.bank_accounts.office.bankers_name_and_address'
          ) {
            return (
              <>
                <h3>Office Account</h3>
                <Field
                  key={field.name}
                  name={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              </>
            );
          }
          if (
            field.name === 'data.attributes.metadata.bank_accounts.client.account_name'
          ) {
            return (
              <>
                <h3>Client or Insurer Account</h3>
                <Field
                  key={field.name}
                  name={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              </>
            );
          }
          if (
            field.name ===
            'data.attributes.metadata.bank_accounts.other_information.cass_rules'
          ) {
            return (
              <>
                <h3>Other Information</h3>
                <FormGroup key={field.name}>
                  <Col sm={8}>
                    <ControlLabel>{field.label}</ControlLabel>
                  </Col>
                  <Col sm={3}>
                    <div className={'broker-application-answers'}>
                      <Field
                        name={field.name}
                        component={ButtonGroup}
                        inline
                        options={[
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ]}
                      />
                    </div>
                  </Col>
                </FormGroup>
              </>
            );
          }
          switch (field.type) {
            case 'name': {
              return (
                <>
                  <h3>Monthly Accounts Contact Information</h3>
                  <NameFields
                    key={field.name}
                    baseName={field.name}
                    label={field.label}
                    labelSize={3}
                  />
                </>
              );
            }
            case 'email': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'currency': {
              return (
                <Field
                  key={field.name}
                  name={field.name}
                  labelSize={3}
                  fieldSize={4}
                  currency
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'input': {
              return (
                <Field
                  key={field.name}
                  name={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'date': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={3}
                  fieldSize={4}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'select': {
              return (
                <FormGroup key={field.name}>
                  <Col sm={8}>
                    <ControlLabel> {field.label}</ControlLabel>
                  </Col>
                  <Col sm={3}>
                    <Field
                      name={field.name}
                      key={field.name}
                      // label={field.label}
                      // labelSize={2}
                      // fieldSize={2}
                      component={SelectField}
                      options={[
                        { value: 'statutory_trust', label: 'Statutory Trust' },
                        { value: 'non_statutory_trust', label: 'Non-Statutory Trust' },
                      ]}
                    />
                  </Col>
                </FormGroup>
              );
            }
            case 'question': {
              return (
                <FormGroup key={field.name}>
                  <Col sm={8}>
                    <ControlLabel>{field.label}</ControlLabel>
                  </Col>
                  <Col sm={3}>
                    <div className={'broker-application-answers'}>
                      <Field
                        name={field.name}
                        component={ButtonGroup}
                        inline
                        options={[
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ]}
                      />
                    </div>
                  </Col>
                </FormGroup>
              );
            }
          }
        })}
      </Box>
    );
  }
}

export default connect((state, props) => {
  return {
    formValues: getFormValues(props.form)(state),
  };
})(BankAccounts);
